import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { CommentAPIModel } from 'src/app/models/api.model'
import { CommonService } from 'src/app/services/common/common.service'

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
//TODO:- Refactor Component name refactor code
export class CommentComponent implements OnInit, OnChanges {
  commentForm: FormGroup

  @Input() comments: CommentAPIModel[] = []
  @Input() statusChange: boolean
  @Input() disableAddComment: boolean = false
  @Output() add: EventEmitter<CommentAPIModel> = new EventEmitter<CommentAPIModel>()
  @Output() mandatoryflag: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output() notifyChange: EventEmitter<boolean> = new EventEmitter<boolean>()
  newComments: CommentAPIModel[] = []
  private readonly NOTIFY = 'notify'
  readonly COMMENT = 'comment'

  constructor(private formBuilder: FormBuilder, private cs: CommonService) {}

  ngOnChanges(changes: SimpleChanges): void {
    const commentControl = this.commentForm?.get(this.COMMENT)
    if (this.statusChange) {
      commentControl?.setValidators([Validators.minLength(5), Validators.maxLength(255), Validators.required])
    } else {
      commentControl?.clearValidators()
    }
    commentControl?.updateValueAndValidity()
  }

  ngOnInit() {
    this.buildCommentForm()
  }

  private buildCommentForm() {
    this.commentForm = this.formBuilder.group({
      [this.NOTIFY]: [false],
      [this.COMMENT]: ['', [Validators.minLength(5), Validators.maxLength(255), Validators.required]]
    })
  }

  addComment() {
    const commentControl = this.f[this.COMMENT]
    const errors = commentControl.errors
    if (errors) {
      if (errors['required']) {
        return this.cs.showError('Comment is mandatory')
      }
      if (errors['maxlength']) {
        return this.cs.showError(`Max ${errors['maxlength'].requiredLength} characters allowed for comment`)
      }
    }
    const comment = commentControl.value
    if (this.statusChange && comment.length < 5) {
      this.mandatoryflag.emit(true)
    } else {
      this.mandatoryflag.emit(false)
    }
    const commentAPIModel = {
      comment
    } as any
    this.add.emit(commentAPIModel)
  }

  onNotifyChange() {
    this.notifyChange.emit(this.commentForm?.get(this.NOTIFY)?.value)
  }

  get f() {
    return this.commentForm.controls
  }
}
